import { render, staticRenderFns } from "./MortgageSummary.vue?vue&type=template&id=dccae9fe&scoped=true&"
import script from "./MortgageSummary.vue?vue&type=script&lang=js&"
export * from "./MortgageSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dccae9fe",
  null
  
)

export default component.exports